
import { useSelector } from "react-redux";

export default function useCurrentUser() {

  const user = useSelector(({ auth }) => auth.user);

  return user
}